import { NavLink, useNavigate } from "react-router-dom";
import { Add as AddIcon } from "@mui/icons-material";
import { Button } from "@mui/material";
import { Flex } from "@100mslive/roomkit-react";
import { SESSION_AUTH } from "../../common/auth";

const AIChatTabs = () => {
  const { isUserSession } = SESSION_AUTH();
  const navigate = useNavigate();

  const reLoadChat = () => {
    setTimeout(function () {
      navigate("/R_C_P", {
        state: { replace: true, redirectOn: "/ai/chat" },
      });
    }, 100);
  };
  return (
    <Flex
      justify="between"
      align="center"
      className="events6ix-layout-page-header events-page-aichat-header"
    >
      <div className="events6ix-layout-page-header-menu">
        <NavLink
          to="/ai/chat"
          className="events6ix-layout-page-header-menu-link"
          onClick={reLoadChat}
        >
          Chat
        </NavLink>
        {isUserSession ? (
          <NavLink
            to="/ai/history"
            className="events6ix-layout-page-header-menu-link"
          >
            History
          </NavLink>
        ) : null}
      </div>

      <Flex className="events6ix-layout-page-header-right" align="center">
        <Button
          color="primary"
          variant="outlined"
          className="events6ix-btn events6ix-btn-primary"
          startIcon={<AddIcon fontSize="small" />}
          onClick={reLoadChat}
        >
          New Chat
        </Button>
      </Flex>
    </Flex>
  );
};

export default AIChatTabs;
